module.exports = __webpack_public_path__ + "img/kankou_14.70c92888.jpg";